import { Injectable } from '@angular/core';
import * as lodash from 'lodash';



export function mapWherePropertiesMatch(target: object, source: object): any {
  const result = lodash.cloneDeep(target);
  for (let property in source) {
    if (source.hasOwnProperty(property)) {
      if (result.hasOwnProperty(property)) {
        result[property] = source[property];
      }
    }
  }
  return result;
}


/**
 * @deprecated Use the exported function instead
 */
@Injectable()
export class ObjectMapperService {

  mapWherePropertiesMatch(target: object, source: object): any {
    return mapWherePropertiesMatch(target, source);
  }

}
